import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild, inject, input } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams } from '@camelot/menu';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, ButtonSize, LayoutFullPanelComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { CamTranslationGrid } from '../../../translation.service';
import { AbstractGridComponent } from '../../abstract-grid.component';
import { ViewsSelectionComponent } from '../views-selection.component';

@Component({
  imports: [ButtonComponent, CommonModule, LayoutFullPanelComponent, TranslatePipe, ViewsSelectionComponent],
  selector: 'cam-views-selection-displayer',
  templateUrl: './views-selection-displayer.component.html',
})
export class ViewSelectionDisplayerComponent extends AbstractGridComponent<any> {
  label = input<string>();

  size = input<ButtonSize>('md');

  @ViewChild('template', { read: TemplateRef })
  template!: TemplateRef<void>;

  get isOpen() {
    return this._isOpen;
  }
  set isOpen(value: boolean) {
    this._isOpen = value;

    if (this.mobileDetection) {
      if (value) {
        this._bottomSheet.open<BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams<null>>(
          BottomSheetTemplateGenericComponent,
          {
            data: {
              context: null,
              template: this.template,
            },
            panelClass: 'no-padding',
          }
        );
      } else {
        this._bottomSheet.dismiss();
      }
    }
  }
  get mobileDetection() {
    return this.breakpoints.isMobile;
  }

  private _isOpen = false;

  private readonly _bottomSheet = inject(MatBottomSheet);

  constructor() {
    super();
    CamTranslationCore.getInstance();
    CamTranslationGrid.getInstance();
  }

  public close() {
    this.isOpen = false;
  }
  public open() {
    this.isOpen = true;
  }

  public selected(_filters: any) {
    this.close();
  }
}
